import { useMemo } from "react";
import { useKlydoMonitors } from "../../KlydoMonitor/hooks/useKlydoMonitors";
import { incidentClockIds } from "../../KlydoMonitor/incidentClockIds";
import DSAutocomplete from "../../system-design/DSAutocomplete";
import DSTextField from "../../system-design/DSTextField";

type MonitorFilterProps = {
  monitorId: string;
  onChange: (monitorId: string | null) => void;
};

const MonitorFilter = ({ monitorId, onChange }: MonitorFilterProps) => {
  const { data: monitors, isLoading } = useKlydoMonitors();

  const options = useMemo(
    () =>
      (monitors ?? [])
        .filter(
          (monitor) =>
            incidentClockIds(monitor).length > 0 || monitor.id === monitorId,
        )
        .sort((a, b) => a.name.localeCompare(b.name)),
    [monitors, monitorId],
  );

  return (
    <DSAutocomplete
      size="small"
      sx={{ width: 260 }}
      options={options}
      loading={isLoading}
      value={options.find((monitor) => monitor.id === monitorId) ?? null}
      getOptionLabel={(monitor) =>
        `${monitor.name} (${incidentClockIds(monitor).length})`
      }
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      noOptionsText="No monitor has failing clocks"
      onChange={(_, monitor) => onChange(monitor?.id ?? null)}
      renderInput={(params) => <DSTextField {...params} label="Monitor" />}
    />
  );
};

export default MonitorFilter;
